import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    BooleanInput,
    required,
    useRecordContext,
} from 'react-admin';
import { Box, Typography } from '@mui/material';
import { hotlineBlocklistFields } from '../hotlineBlocklist.model';
import { useEditWithRefresh } from '../../hooks/useMutationWithRefresh';
import { 
    validatePhoneNumber, 
    validateNotes, 
    validateHotlineBlocklistEdit 
} from '../utils/hotlineBlocklistValidators';
import PhoneNumberField from './fields/phoneNumberField.component';

const HotlineBlocklistTitle = () => {
    const record = useRecordContext();
    return record ? `Blocked Number ${record.id}` : 'Edit Blocked Number';
};

const HotlineBlocklistEdit = () => {
    const mutationOptions = useEditWithRefresh('hotline-blocklist', {
        successMessage: 'Blocked number updated successfully',
    });

    return (
        <Edit
            title={<HotlineBlocklistTitle />}
            mutationMode="pessimistic"
            mutationOptions={mutationOptions}
        >
            <SimpleForm validate={validateHotlineBlocklistEdit}>
                <Typography variant="h6" gutterBottom>
                    Edit Blocked Phone Number
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                    Update the phone number, hotline settings, or notes for this blocked number.
                </Typography>
                
                <TextInput
                    label="Phone Number"
                    source={hotlineBlocklistFields.phoneNumber}
                    validate={validatePhoneNumber}
                    placeholder="e.g., +15551234567, 5551234567, or (555) 123-4567"
                    helperText="Enter in any format - will be normalized automatically"
                    sx={{ width: 400 }}
                />
                
                <Box sx={{ mt: 2, mb: 2 }}>
                    <Typography variant="subtitle2" gutterBottom>
                        Apply to Hotlines:
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <BooleanInput
                            label="Texas Hotline"
                            source={hotlineBlocklistFields.appliesToTx}
                        />
                        <BooleanInput
                            label="Tennessee Hotline"
                            source={hotlineBlocklistFields.appliesToTn}
                        />
                    </Box>
                </Box>
                
                <TextInput
                    label="Notes"
                    source={hotlineBlocklistFields.notes}
                    validate={validateNotes}
                    multiline
                    rows={4}
                    placeholder="Optional: Add context or reason for blocking this number"
                    sx={{ width: 400 }}
                />
            </SimpleForm>
        </Edit>
    );
};

export default HotlineBlocklistEdit; 